import { render } from "./ContactView.vue?vue&type=template&id=2971d27a&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=2971d27a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2971d27a"]])

export default __exports__